import { render, staticRenderFns } from "./new-year-draw-2021.vue?vue&type=template&id=5d9bf78a&scoped=true&"
import script from "./new-year-draw-2021.vue?vue&type=script&lang=js&"
export * from "./new-year-draw-2021.vue?vue&type=script&lang=js&"
import style0 from "./new-year-draw-2021.vue?vue&type=style&index=0&id=5d9bf78a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9bf78a",
  null
  
)

export default component.exports